export default __webpack_public_path__ + "static/media/timeline_3.bd233f96.svg";